/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { customerDetails } from "Stores/customerDetails";
import ContactInfo from "./ContactInfo";
import { observer } from "mobx-react";
import CustomerSubscription from "./CustomerSubscriptionDetails";
import WipeAllData from "./WipeAllData";
import UsageInfo from "./UsageInfo";
import CreditsInfo from "./CreditsInfo";

const CustomerProfile = observer(() => {
  const [subscriptionsData, setSubscriptions] = useState([]);
  const [teamData, setTeamData] = useState({});
  const [teamMember, setTeamMember] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [jobStatus, setJobStatus] = useState(null);
  const [inboxConnected, setInboxConnected] = useState(false);
  const [connectedInbox, setInboxConnectedInbox] = useState("");

  const constructCustomerData = (customerData) => {
    if (customerData && Object.keys(customerData).length) {
      const {
        teamSubscriptions = "",
        member = "",
        teamMembers = [],
        team = {},
        isInboxConnected,
        connectedInbox = {},
      } = customerData;

      setTeamMember(teamMembers);
      setInboxConnected(isInboxConnected);
      setInboxConnectedInbox(connectedInbox?.email);
      teamSubscriptions && setSubscriptions(teamSubscriptions);
      const {
        creditsEligible = 0,
        creditsUsed = 0,
        snImportUsed = 0,
        snImportEligible = 0,
        snContactsEligible = 0,
        snContactsUsed = 0,
        emailSendLimit = 0,
        emailSentCount = 0,
        emailValidationCredits = 0,
        usFreeCallingMinutesEligible = 0,
        usFreeCallingMinutesUsed = 0,
        dialerCredits = 0,
        liMonthlyMessageEligible = 0,
        liMonthlyMessageUsed = 0,
        liMonthlyInviteEligible = 0,
        liMonthlyInviteUsed = 0,
      } = team || {};

      let memberWithCredits = {};
      if (member) {
        memberWithCredits = {
          ...member,
          creditsEligible: creditsEligible,
          creditsUsed: creditsUsed,
          snImportUsed: snImportUsed,
          snImportEligible: snImportEligible,
          snContactsEligible: snContactsEligible,
          snContactsUsed: snContactsUsed,
          emailSendLimit: emailSendLimit,
          emailSentCount: emailSentCount,
          emailValidationCredits: emailValidationCredits,
          usFreeCallingMinutesEligible: usFreeCallingMinutesEligible,
          usFreeCallingMinutesUsed: usFreeCallingMinutesUsed,
          dialerCredits: dialerCredits,
          liMonthlyMessageEligible: liMonthlyMessageEligible,
          liMonthlyMessageUsed: liMonthlyMessageUsed,
          liMonthlyInviteEligible: liMonthlyInviteEligible,
          liMonthlyInviteUsed: liMonthlyInviteUsed,
        };
      }
      member && setMemberData(memberWithCredits);
      team && setTeamData(team);
    }
  };

  useEffect(() => {
    constructCustomerData(customerDetails.customerData);
  }, [customerDetails.customerData]);

  useEffect(() => {
    setJobStatus(customerDetails.jobStatus);
  }, [customerDetails.jobStatus]);

  return (
    <div className="customerProfileDetails">
      <ContactInfo
        memberData={memberData}
        subscriptionsData={subscriptionsData}
        teamData={teamData}
        teamMemberData={teamMember}
        connectedInbox={connectedInbox}
      />
      <CreditsInfo memberData={memberData} />
      <UsageInfo
        teamData={teamData}
        inboxConnected={inboxConnected}
        memberData={memberData}
      />
      <CustomerSubscription data={subscriptionsData} />
      <WipeAllData data={teamMember} jobStatus={jobStatus} cbk={setJobStatus} />
    </div>
  );
});

export default CustomerProfile;
export { CustomerProfile };
